interface Props {
  kind: 'percentile-estimate' | 'mean-approx' | 'hourly-mean';
}

const COPY = {
  'percentile-estimate': {
    label: 'estimate',
    title: 'Derived from stored hourly percentiles because the range extends past raw-check retention. '
      + 'Percentiles do not roll up, so this may differ from a true p95 in either direction.',
  },
  'mean-approx': {
    label: 'approx.',
    title: 'Weighted by total checks because some hours predate response-count tracking, '
      + 'which slightly over-weights hours with failed checks.',
  },
  'hourly-mean': {
    label: 'hourly avg',
    title: 'This window holds more checks than the chart samples, so each point is the hourly '
      + 'average from the rollup. The current hour appears once it has been rolled up.',
  },
} as const;

export function EstimateBadge({ kind }: Props) {
  const { label, title } = COPY[kind];
  return (
    <span
      className="ml-1 align-middle text-[10px] uppercase tracking-wide px-1 py-0.5 rounded
                 bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300 cursor-help"
      title={title}
    >
      {label}
    </span>
  );
}
